import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../styles/variables";
import ImgixImg from "./ImgixImg";

interface ImageSliderProps {
  images: {
    url: string;
  }[];
  imgixParams: {
    w: number;
    h?: number;
    fit?: string;
    crop?: string;
    q?: number;
  };
}

const Slider = styled.div`
  position: relative;
  overflow: hidden;

  > img {
    display: block;
    width: 100%;
  }
`;

const NavButton = styled.button<{ direction: "prev" | "next" }>`
  position: absolute;
  top: 50%;
  ${(props) => (props.direction === "prev" ? "left: 12px;" : "right: 12px;")}
  z-index: 1;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.86);
  cursor: pointer;
  transform: translateY(-50%);
  transition: background-color 0.2s ease-in-out;

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    border-top: 2px solid ${colors.green};
    border-right: 2px solid ${colors.green};
    content: "";
    transform: translate(-50%, -50%)
      rotate(${(props) => (props.direction === "prev" ? "225deg" : "45deg")});
  }

  &:hover,
  &:focus {
    background: #fff;
  }
`;

const ImageSlider: React.FC<ImageSliderProps> = ({ images, imgixParams }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const hasMultipleImages = images.length > 1;

  useEffect(() => {
    if (!hasMultipleImages || isPaused) {
      return undefined;
    }

    const interval = window.setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % images.length);
    }, 10000);

    return () => window.clearInterval(interval);
  }, [hasMultipleImages, images.length, isPaused]);

  const showPrevious = () => {
    setActiveIndex(
      (currentIndex) => (currentIndex - 1 + images.length) % images.length
    );
  };

  const showNext = () => {
    setActiveIndex((currentIndex) => (currentIndex + 1) % images.length);
  };

  return (
    <Slider
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <ImgixImg src={images[activeIndex].url} imgixParams={imgixParams} />
      {hasMultipleImages && (
        <>
          <NavButton
            aria-label="Vorheriges Bild"
            direction="prev"
            onClick={showPrevious}
            type="button"
          />
          <NavButton
            aria-label="Nächstes Bild"
            direction="next"
            onClick={showNext}
            type="button"
          />
        </>
      )}
    </Slider>
  );
};

export default ImageSlider;
